import { Alert, Button, IconButton, Snackbar } from '@mui/joy'
import { type FC } from 'react'
import { useTranslation } from 'react-i18next'
import { TbExclamationCircle, TbX } from 'react-icons/tb'
import { Link } from 'react-router-dom'

import { useAppDispatch } from '../../store'
import { isDispatchAction, isExternalAction } from '../../store/notifications/types'
import { SNACKBAR_SX } from './snackbarSx'
import { type NotificationViewProps } from './types'

const ACTION_SX = { fontWeight: 600, whiteSpace: 'nowrap' }

const ErrorSnackbar: FC<NotificationViewProps> = ({ notification, onClose, ...props }) => {
  const { t } = useTranslation()
  const dispatch = useAppDispatch()
  const action = notification.extra?.action

  return (
    <Snackbar
      {...props}
      color="danger"
      variant="soft"
      sx={SNACKBAR_SX}
      anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
    >
      <Alert
        color="danger"
        variant="solid"
        sx={{ width: '100%' }}
        startDecorator={<TbExclamationCircle size={24} />}
        invertedColors
        endDecorator={
          <>
            {action && isDispatchAction(action) && (
              <Button
                variant="plain"
                size="sm"
                sx={ACTION_SX}
                onClick={(event) => {
                  dispatch(action.dispatch)
                  onClose?.(event, 'escapeKeyDown')
                }}
              >
                {action.label}
              </Button>
            )}
            {action && !isDispatchAction(action) && !isExternalAction(action) && (
              <Button component={Link} to={action.path} variant="plain" size="sm" sx={ACTION_SX}>
                {action.label}
              </Button>
            )}
            <IconButton
              variant="plain"
              aria-label={t('notifications.close')}
              onClick={onClose as any}
            >
              <TbX size={24} />
            </IconButton>
          </>
        }
      >
        {notification.message}
      </Alert>
    </Snackbar>
  )
}

export default ErrorSnackbar
